export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9854.bc015ff2.jpg";